import {
  ADDITIONAL_ENGLISH_TEXT_KEY,
  ADDITIONAL_KAZAKH_TEXT_KEY,
  ADDITIONAL_RUSSIAN_TEXT_KEY,
  ENGLISH_TITLE_KEY,
  IMAGE_URL_KEY,
  KAZAKH_TITLE_KEY,
  RUSSIAN_TITLE_KEY,
} from '@esentai/core/features/campaigns/article/consts/keys';
import { Grid } from '@material-ui/core';
import React, { Component } from 'react';

import FieldDescription from '@/components/FieldDescription';
import FieldRow from '@/components/FieldRow';
import ImageField from '@/components/ImageField';
import TextField from '@/components/TextField';
import limits from '@/features/campaignCreatePage/EditPage/limits';
import FormikPropTypes from '@/prop-types/formik';

import { CanEdit } from '../../CanEdit';
import Preview from './Preview';

class ContentForm extends Component {
  static propTypes = FormikPropTypes;

  setImageUrl = urls => {
    const { setFieldValue } = this.props;
    const [url] = urls;

    setFieldValue(IMAGE_URL_KEY, url);
  };

  renderPreview = () => {
    const { values } = this.props;

    return (
      <Preview
        imageUrl={values[IMAGE_URL_KEY]}
        englishTitle={values[ENGLISH_TITLE_KEY]}
        russianTitle={values[RUSSIAN_TITLE_KEY]}
        kazakhTitle={values[KAZAKH_TITLE_KEY]}
        additionalEnglishText={values[ADDITIONAL_ENGLISH_TEXT_KEY]}
        additionalRussianText={values[ADDITIONAL_RUSSIAN_TEXT_KEY]}
        additionalKazakhText={values[ADDITIONAL_KAZAKH_TEXT_KEY]}
        hasKazakh
      />
    );
  };

  render() {
    const { Field, values } = this.props;
    const imageId = values[IMAGE_URL_KEY];

    return (
      <FieldRow
        label="Наполнение баннера"
        subLabel="Изображение баннера"
        sudDesc="Баннер обязательно должен иметь изображение"
        Aside={this.renderPreview}
      >
        <Grid container spacing={40}>
          <Grid item xs={12}>
            <CanEdit field={IMAGE_URL_KEY}>
              <ImageField
                ids={imageId ? [imageId] : []}
                onChange={this.setImageUrl}
              />
            </CanEdit>
          </Grid>

          <Grid item xs={12}>
            <FieldDescription
              title="Заголовок баннера"
              desc="Заголовок будет отображаться под баннером. Не более 50 символов."
            />
            <CanEdit field={RUSSIAN_TITLE_KEY}>
              <Field
                Target={TextField}
                name={RUSSIAN_TITLE_KEY}
                symbolsMax={limits.title}
                helperText="На русском"
                fullWidth
              />
            </CanEdit>
            <CanEdit field={ENGLISH_TITLE_KEY}>
              <Field
                Target={TextField}
                name={ENGLISH_TITLE_KEY}
                symbolsMax={limits.title}
                helperText="На английском"
                fullWidth
              />
            </CanEdit>
            <CanEdit field={KAZAKH_TITLE_KEY}>
              <Field
                Target={TextField}
                name={KAZAKH_TITLE_KEY}
                symbolsMax={limits.title}
                helperText="На казахском"
                fullWidth
              />
            </CanEdit>
          </Grid>
        </Grid>
      </FieldRow>
    );
  }
}

export default ContentForm;
